import ky from 'ky'
import {getConfiguredCache} from 'money-clip'
import ms from 'ms'

const MAX_MOLECULES = 25
const MAX_KNN = 5
const API_VERSION = 1
const API_URL = "/api"
  // "http://localhost:5050/api"
  // 'https://etx-drugdesign-655b23c805bbfc0dc20dafae14e8fd17-0000.us-south.containers.appdomain.cloud/api'
  // 'https://staging.etx-drugdesign-655b23c805bbfc0dc20dafae14e8fd17-0000.us-south.containers.appdomain.cloud/api'
// 'https://etx-drugdesign-655b23c805bbfc0dc20dafae14e8fd17-0000.us-south.containers.appdomain.cloud/api'
  //'https://staging.etx-drugdesign-655b23c805bbfc0dc20dafae14e8fd17-0000.us-south.containers.appdomain.cloud/api'

const cache = (() => {
  const _cache = getConfiguredCache({
    version: API_VERSION,
    maxAge: ms(process.env.NODE_ENV === 'production' ? '20m' : '1s'),
    name: 'api'
  })
  _cache.has = async key => !!(await cache.get(key))
  return _cache
})()

const memoize = (fn, {cacheKey, cache}) => async (...args) => {
  const key = cacheKey(args)
  let value = await cache.get(key)
  if (value) return value
  value = await fn.apply(this, args)
  await cache.set(key, value)
  return value
}

const doGet = async (input, {mapper, ...opts}) => {
  const body = await ky.get(input, {prefixUrl: API_URL, ...opts}).json()
  return mapper(body)
}

const doFetch = async (input, {mapper, ...opts}) => {
  const body = await ky.post(input, {prefixUrl: API_URL, ...opts}).json()
  return mapper(body)
}

const api = memoize(doFetch, {
  cacheKey: args => JSON.stringify(args),
  cache
})

export const getMolecules = body =>
  api('topX', {
    method: 'POST',
    json: {
      p_id: body.target,
      x: MAX_MOLECULES,
      k: MAX_KNN,
      filters: body.filters,
      sort: body.sort,
      subset: body.subset
    },
    mapper: body => body.result.mols
  })

export const getMCS = smiles_list =>
  api('MCS', {
    method: 'POST',
    json: {
      smiles: smiles_list
    },
    mapper: body => body.result.mcs_smiles
  })

export const getOwn = body =>
  api('usermol', {
    method: 'POST',
    json: {
      k: 5,
      p_id: body.target,
      usermol: body.usermol
    },
    mapper: body => body
  })

export const getByID = body =>
  doGet(`get_by_id?p_id=${encodeURIComponent(body.projectID)}&mol_id=${encodeURIComponent(
    body.molID)}&return_rxn=true`, {
    method: 'GET',
    mapper: d => d
  })
